import React, { useEffect } from 'react';
import './BtsPopup.css';

const ICONS = {
  error: '⚠️',
  success: '🎉',
  info: 'ℹ️',
  warning: '⚡',
};

const BtsPopup = ({ title, message, type = 'error', onClose, actions }) => {
  // ล็อค scroll ข้างหลังเมื่อ popup แสดง
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div className="bts-popup__overlay">
      <div className="bts-popup">
        <div className={`bts-popup__icon-wrap bts-popup__icon-wrap--${type}`}>
          <span className="bts-popup__icon">{ICONS[type] || ICONS.error}</span>
        </div>

        {title && <h3 className="bts-popup__title">{title}</h3>}
        {message && <p className="bts-popup__message">{message}</p>}

        <div className="bts-popup__actions">
          {actions ? (
            actions.map((action, i) => (
              <button
                key={i}
                className={`bts-popup__btn ${action.primary ? 'bts-popup__btn--primary' : 'bts-popup__btn--secondary'}`}
                onClick={action.onClick || onClose}
              >
                {action.label}
              </button>
            ))
          ) : (
            <button className="bts-popup__btn bts-popup__btn--primary" onClick={onClose}>
              ตกลง
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BtsPopup;
